import { Collection } from "@datx/core";
import { jsonapi } from "@datx/jsonapi";
import LoadStatus from "../models/loadStatus";
import User from "../models/user";

export default class UserStore extends jsonapi(Collection) {
  static types = [User, LoadStatus];
}
